import { Checkbox, FormControlLabel, Stack, Link } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';

interface TermsAndPrivacyCheckboxesProps {
  acceptTermsChecked: boolean;
  onAcceptTermsChange: (checked: boolean) => void;
  onTermsLinkClick: () => void;
  showTermsCheckbox: boolean;
}

export const TermsAndPrivacyCheckboxes = ({
  acceptTermsChecked,
  onAcceptTermsChange,
  onTermsLinkClick,
  showTermsCheckbox,
}: TermsAndPrivacyCheckboxesProps) => {
  const t = useTranslations();

  if (!showTermsCheckbox) {
    return null;
  }

  return (
    <Stack spacing={0} sx={{ '& > *': { margin: 0, padding: 0 } }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={acceptTermsChecked}
            onChange={(e) => onAcceptTermsChange(e.target.checked)}
            size="small"
            color="primary"
            sx={{ p: 1 }}
          />
        }
        label={
          <>
            {t('myEventsList.contributionsList.acceptTerms')}{' '}
            <Link
              component="button"
              variant="caption"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onTermsLinkClick();
              }}
              sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'text.primary' }}
            >
              {t('myEventsList.contributionsList.termsOfContribution')}
            </Link>
          </>
        }
        slotProps={{ typography: { variant: 'caption' } }}
        sx={{ 'm': 0, 'p': 0, 'alignItems': 'center', '& .MuiFormControlLabel-label': { p: 0 } }}
      />
    </Stack>
  );
};
